import React from 'react';
import Marker from './Marker';

const LocationMarkers = ({ entities, markerRef }) => {

  return entities.map((entity) => {
    const coordinates = entity.getIn(['field_geo_coordinates', 0, 'latlon'], null);

    return (
      (coordinates && (
        <Marker
          entity={entity}
          reference={markerRef}
        />
      ))
    );
  });
};

export default LocationMarkers;
